export default __webpack_public_path__ + "img/98c53d521a5b49793442c7bec126b419.svg";